import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { AnswerShape, ANSWER_BORDERS, ANSWER_COLORS } from "./AnswerShape";

export const AnswerTile = ({ i, text, reveal, correct, count, total }) => {
  const pct = total ? Math.round((count / total) * 100) : 0;
  const size = text.length > 60 ? "1.6em" : text.length > 35 ? "1.9em" : "2.2em";
  return (
    <motion.div
      data-testid={`host-answer-tile-${i + 1}`}
      initial={{ scale: 0.6, opacity: 0 }}
      animate={{ scale: 1, opacity: reveal && !correct ? 0.35 : 1 }}
      transition={{ delay: reveal ? 0 : i * 0.08, type: "spring", stiffness: 380, damping: 22 }}
      className={`relative flex items-center gap-[1em] px-[1.2em] overflow-hidden ${reveal && correct ? "pulse-glow" : ""}`}
      style={{
        background: ANSWER_COLORS[i],
        boxShadow: `0 -0.3em 0 0 #1a1420, 0 0.3em 0 0 #1a1420, -0.3em 0 0 0 #1a1420, 0.3em 0 0 0 #1a1420, inset 0 -0.5em 0 0 ${ANSWER_BORDERS[i]}`,
      }}
    >
      {reveal && (
        <motion.div
          className="absolute left-0 top-0 bottom-0 bg-white/20"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      )}
      <AnswerShape i={i} size="2.4em" />
      <div className="relative flex-1 font-pixel font-bold text-white leading-tight" style={{ fontSize: size, textShadow: "0.08em 0.08em 0 rgba(0,0,0,0.45)" }}>
        {text}
      </div>
      {reveal && (
        <div className="relative flex items-center gap-[0.6em]">
          {correct && (
            <div className="bg-white rounded-full p-[0.3em]" data-testid={`host-answer-correct-${i + 1}`}>
              <Check style={{ width: "1.8em", height: "1.8em", color: "#26890C" }} strokeWidth={4} />
            </div>
          )}
          <span className="font-num text-[3em] text-white leading-none" data-testid={`host-answer-count-${i + 1}`} style={{ textShadow: "0.08em 0.08em 0 #000" }}>
            {count}
          </span>
        </div>
      )}
    </motion.div>
  );
};
